import { GithubTokenMessageListenerService } from './github-token-message-listener.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GithubWdfTokenRequestListener extends GithubTokenMessageListenerService {
  domain = 'github.wdf.sap.corp';
}
